import {FacebookService, InitParams} from 'ngx-facebook';
import {strToArray} from './service/utils';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';


export const FBInitParams: InitParams = {
    appId: '702139329921054',
    version: 'v3.3',
    xfbml: true
  };

export const FBLoginScopes = 'email,public_profile,manage_pages,ads_management,business_management';

export const enum FBLoginStatusEnum {
  Authorized,
  Unidentified,
  Connected,
  NotAuthorized,
  NotLogin,
  NotConnected,
  NotPermitted,
  NotMember,
  InvalidToken,
  Expired,
};


export class FBLogin {
  constructor(private fb: FacebookService,
              private router: Router,
              private http: HttpClient) {
    this.fb.init(FBInitParams);
  }

  login(next: string = '/manager/createAds') {
    const redirects = {};
    redirects[FBLoginStatusEnum.Authorized] = next;

    this.fb.login({
      scope: FBLoginScopes,
      return_scopes: true,
      enable_profile_selector: true,
    }).then( respLogin => {
      this.actionAfterLogin(respLogin, redirects);
    });
  }

  actionAfterLogin = (respLogin, redirects) => {
    if (respLogin.status === 'connected') {
      if (respLogin.authResponse && this.hasPermissions(respLogin.authResponse.grantedScopes)) {
        this.settingForAuthorizedUser(respLogin, redirects);
      } else {
        this.router.navigate([redirects[FBLoginStatusEnum.NotPermitted]]);
      }
    } else if (respLogin.status === 'not_authorized') {
      this.router.navigate([redirects[FBLoginStatusEnum.NotAuthorized]]);
    } else {
      this.router.navigate([redirects[FBLoginStatusEnum.NotConnected]]);
    }
  };

  autoRedirectAftercheckLoginStatus(next: string = '/manager/createAds') {
    const redirects = {};
    redirects[FBLoginStatusEnum.Authorized] = next;
    redirects[FBLoginStatusEnum.InvalidToken] = '/auth';

    this.fb.getLoginStatus().then(respLogin => {
      if (respLogin.status === 'connected' && respLogin.authResponse.userID === localStorage.getItem('user_id')) {
        this.fb.api('/me/permissions').then(respPerm => {
          if (respPerm && respPerm.data && this.hasPermissions(respPerm.data)) {
            this.settingForAuthorizedUser(respLogin, redirects)
          }
        });
      }
    });
  }


  // curl "https://graph.facebook.com/v3.0/oauth/access_token?grant_type=fb_exchange_token&client_id=702139329921054&client_secret=b8259f6001e8199ef99fea11a4dc488c&fb_exchange_token=EAAJZBl41XwB4BABxw1NvKqxLnnXBGzO8etZBD416KrSFjnGkSJoHncCrI1xiuHhyfZCMOjIkBXk4XXuS1d9MGRKiZCqQ7yuWsPTgQzZCUJCY072ZBBkZCiah6KKmzAfvQZAWZBqjnm06uu5YGuir01eGZCQpcRjorCcCq2K6A7ZAAJvAhFRONUknbRhYUznJwewmyJQ7ZAgytSDyLwZDZD&fields=access_token,access_token_expires"
  settingForAuthorizedUser(respLogin, redirects) {
    const u1 = 'https://289tcifrlh.execute-api.ap-northeast-2.amazonaws.com/v1/fb/token';
    const p1 = { access_token: respLogin.authResponse.accessToken };
    this.http.post(u1, p1).subscribe(
      resp => {
        try {
          Object.keys(resp).forEach(value => {
            if (typeof(resp[value]) !== 'object') {
              localStorage.setItem(value, resp[value]);
            }
          });
          this.router.navigate([redirects[FBLoginStatusEnum.Authorized]]);
        } catch (e) {
          console.error(e);
          this.router.navigate([redirects[FBLoginStatusEnum.InvalidToken]]);
        }
      }
    );

    function isMember(me: any) {
      let is = false;
      if (me.businesses && me.businesses.data) {
        is = me.businesses.data.filter( _business => _business.id === '447036208802117').length > 0;
      }
      return is;
    }
  }

  hasPermissions(permissions) {
    const allowed = permissions instanceof Array
      ? permissions.filter(p => p.status === 'granted').map(p => p.permission)
      : strToArray(permissions);
    const needed = FBLoginScopes.split(',');
    return needed.filter(p => !allowed.includes(p)).length === 0;
  }
}




// WEBPACK FOOTER //
// ./src/app/manager/shared/fblogin.ts